import { render } from "./FooterContainer.vue?vue&type=template&id=2a77ffed"
import script from "./FooterContainer.vue?vue&type=script&lang=js"
export * from "./FooterContainer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__